import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getEventsService, getMyPageService } from '@musinsa/services-curator';

export const mypageFactory = createQueryKeys('mypage', {
  data: () => ({
    queryKey: ['data'],
    queryFn: getMyPageService,
  }),
  events: () => ({
    queryKey: ['events'],
    queryFn: getEventsService,
  }),
});
